import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

import {
  SettingsArrowLeftIcon,
  SettingsGearIcon,
  SettingsPlugsIcon,
  SettingsUserIcon,
  SettingsUsersIcon,
} from 'assets/icons/settings'

import { SettingsRoutes } from 'app/application/types'
import { useUser } from 'app/user/application'

import { Button } from 'components'

import { SettingsMenu } from '../SettingsMenu'
import styles from './SettingsSidebar.module.scss'

interface SettingsSidebarProps {
  activeRoute: SettingsRoutes
}

const workspaceSettings = [
  {
    key: SettingsRoutes.General,
    adminOnly: false,
    icon: SettingsGearIcon,
  },
  {
    key: SettingsRoutes.Members,
    adminOnly: true,
    icon: SettingsUsersIcon,
  },
  {
    key: SettingsRoutes.ApiKeys,
    adminOnly: false,
    icon: SettingsPlugsIcon,
  },
]

const accountSettings = [{ key: SettingsRoutes.Profile, icon: SettingsUserIcon }]

const SettingsSidebar = ({ activeRoute }: SettingsSidebarProps) => {
  const { t } = useTranslation('settings')
  const navigate = useNavigate()
  const location = useLocation()
  const state: unknown = location.state
  const returnTo =
    state && typeof state === 'object' && 'returnTo' in state && typeof state.returnTo === 'string'
      ? state.returnTo
      : '/'
  const { user } = useUser()

  return (
    <aside className={styles.sidebar}>
      <div className={styles.backRow}>
        <Button
          className={styles.back}
          leftIcon={<SettingsArrowLeftIcon />}
          onClick={() => void navigate(returnTo)}
          variant="tertiary"
        >
          {t('back')}
        </Button>
      </div>
      <nav aria-label={t('navigation')}>
        <SettingsMenu
          activeRoute={activeRoute}
          items={workspaceSettings.filter((item) => !item.adminOnly || user?.isAdmin)}
          title={t('groups.workspace')}
        />
        <SettingsMenu
          activeRoute={activeRoute}
          items={accountSettings}
          title={t('groups.account')}
        />
      </nav>
    </aside>
  )
}

export default SettingsSidebar
